import React, { useState, useEffect, useRef } from "react";
import { BACKEND } from "../config/configEnvs";
import axios from "axios";
import * as XLSX from 'xlsx';
import {
  FaCalendarAlt,
  FaChartBar,
  FaSave,
  FaSearch,
  FaFileExcel,
  FaFileAlt,
} from "react-icons/fa";
import Modal from "../components/ui/Modal";
import { toast } from "react-toastify";
import {
  FaCheck,
  FaFileInvoiceDollar,
  FaStore,
  FaBarcode,
  FaSpinner,
  FaMoneyBillWave,
  FaReceipt,
} from "react-icons/fa";
import LoadingScreen from "../components/ui/temp-screens/LoadingScreen";
import NoDataScreen from "../components/ui/temp-screens/NoDataScreen";
import { FaTimes } from "react-icons/fa";
import FilterHeadersDialog from "../components/dialogs/FilterHeadersDialog";
import { Button } from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import 'tippy.js/dist/tippy.css';
import Selector from "../components/ui/components/Selector";
import { months, years } from "../utils/rawData/dateValues";
import { FormatDateStringGMT5, FormatDateTimeStringGMT5Midnight } from "../utils/FormatDate";
import FilterButton from "../components/ui/components/FilterButton";
import InputFormValue from "../components/ui/components/InputFormValue";
import ItemRowRegistroVentas from "../components/registroVentas/ItemRowRegistroVentas";
import ParseNumberToFloat from "../utils/helpers/ParseNumberToFloat";
import { useSelector } from "react-redux";

const RegistroVentas = () => {

  const [isLoading, setIsLoading] = useState(false)

  const user = useSelector((state) => state.auth.user)

  const [record, setRecord] = useState([])

  const [brandName, setBrandName] = useState("")

  const [month, setMonth] = useState(new Date().getMonth() + 1)
  const [year, setYear] = useState(new Date().getFullYear())

  const [openEditModal, setOpenEditModal] = useState(false)
  const [quoteSelected, setQuoteSelected] = useState(null)

  const [editData, setEditData] = useState({
    descripcion: "",
    tipoComprobante: "",
    numeroComprobante: "",
    archivosVenta: [], // Archivos nuevos a subir
    archivosExistentes: [], // Archivos ya subidos al servidor
    archivosAEliminar: [] // IDs de archivos existentes a eliminar
  })

  const [isSaving, setIsSaving] = useState(false)
  const [uploadProgress, setUploadProgress] = useState({})

  const [openHeadersFilter, setOpenHeadersFilter] = useState(false)

  // Opciones para el selector de tipo de comprobante
  const opcionesTipoComprobante = [
    { label: "No definido", value: "No definido" },
    { label: "Boleta", value: "Boleta" },
    { label: "Factura", value: "Factura" },
    { label: "RH", value: "RH" },
    { label: "Proforma", value: "Proforma" },
    { label: "N/C", value: "N/C" },
    { label: "N/D", value: "N/D" },
    { label: "Tickets", value: "Tickets" },
    { label: "POS", value: "POS" },
  ]

  // Función para manejar cambios en los campos editables
  const handleEditChange = (field, value) => {
    setEditData(prev => ({
      ...prev,
      [field]: value
    }))
  }

  // Función para manejar la subida de archivos
  const handleFileUpload = (event) => {
    const files = Array.from(event.target.files)
    
    // Validar tamaño máximo (10MB por archivo)
    const maxSize = 10 * 1024 * 1024 // 10MB
    const validFiles = files.filter(file => {
      if (file.size > maxSize) {
        toast.error(`El archivo ${file.name} excede el tamaño máximo de 10MB`)
        return false
      }
      return true
    })

    if (validFiles.length === 0) return

    setEditData(prev => ({
      ...prev,
      archivosVenta: [...prev.archivosVenta, ...validFiles]
    }))
  }

  // Función para eliminar archivo nuevo
  const handleRemoveFile = (index) => {
    setEditData(prev => ({
      ...prev,
      archivosVenta: prev.archivosVenta.filter((_, i) => i !== index)
    }))
  }

  // Función para eliminar archivo existente del servidor
  const handleRemoveExistingFile = async (fileId, fileName) => {
    try {
      // Confirmar eliminación
      if (!window.confirm(`¿Estás seguro de que quieres eliminar el archivo "${fileName}"?`)) {
        return
      }

      // Agregar a la lista de archivos a eliminar
      setEditData(prev => ({
        ...prev,
        archivosAEliminar: [...prev.archivosAEliminar, fileId],
        archivosExistentes: prev.archivosExistentes.filter(file => file.id !== fileId)
      }))

      toast.success(`Archivo "${fileName}" marcado para eliminación`)
    } catch (error) {
      toast.error("Error al marcar archivo para eliminación")
      console.error(error)
    }
  } 

  // Función para cancelar eliminación de archivo existente
  const handleCancelRemoveExistingFile = (fileId) => {
    setEditData(prev => ({
      ...prev,
      archivosAEliminar: prev.archivosAEliminar.filter(id => id !== fileId),
      archivosExistentes: [
        ...prev.archivosExistentes,
        ...(quoteSelected.archivosVenta || []).filter(file => file.id === fileId)
      ]
    }))
    toast.success("Eliminación cancelada")
  }

  // Función para descargar archivo existente
  const handleDownloadFile = async (fileId, fileName) => {
    try {
      const response = await axios.get(`${BACKEND}/api/documentosCotizaciones/${fileId}/download`, {
        responseType: 'blob',
        withCredentials: true
      })
      
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
      link.remove()
      window.URL.revokeObjectURL(url)
    } catch (error) {
      toast.error("Error al descargar el archivo")
      console.error(error)
    }
  }

  // Función para validar datos antes de guardar
  const validateForm = () => {
    if (!editData.tipoComprobante || editData.tipoComprobante === "No definido") {
      toast.error("Por favor selecciona un tipo de comprobante")
      return false
    }
    
    if (!editData.numeroComprobante || editData.numeroComprobante.trim() === "") {
      toast.error("Por favor ingresa el número de comprobante")
      return false
    }
    
    if (!editData.descripcion || editData.descripcion.trim() === "") {
      toast.error("Por favor ingresa una descripción")
      return false
    }
    
    return true
  }

  // Función para guardar los cambios
  const handleSaveChanges = async () => {
    if (!validateForm()) {
      return;
    }
    try {
      setIsSaving(true)
      
      // 1. Eliminar archivos marcados para eliminación
      for (const fileId of editData.archivosAEliminar) {
        try {
          await axios.delete(`${BACKEND}/api/documentosCotizaciones/${fileId}`, {
            withCredentials: true
          })
        } catch (error) {
          console.error(`Error eliminando archivo ${fileId}:`, error)
          toast.warning(`No se pudo eliminar un archivo. Continuando con el resto...`)
        }
      }

      // 2. Subir archivos nuevos
      const nuevosDocsVenta = []
      for (let i = 0; i < editData.archivosVenta.length; i++) {
        const file = editData.archivosVenta[i]
        try {
          setUploadProgress(prev => ({ ...prev, [file.name]: 0 }))
          
          const formData = new FormData()
          formData.append("file", file)
          
          const response = await axios.post(`${BACKEND}/api/documentosCotizaciones`, formData, {
            withCredentials: true,
            headers: {
              'Content-Type': 'multipart/form-data'
            },
            onUploadProgress: (progressEvent) => {
              const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
              setUploadProgress(prev => ({ ...prev, [file.name]: percentCompleted }))
            }
          })
          
          nuevosDocsVenta.push(response?.data?.doc?.id)
          setUploadProgress(prev => ({ ...prev, [file.name]: 100 }))
          toast.success(`Archivo "${file.name}" subido exitosamente`)
        } catch (error) {
          console.error(`Error subiendo archivo ${file.name}:`, error)
          toast.error(`Error al subir "${file.name}". Continuando con el resto...`)
          setUploadProgress(prev => ({ ...prev, [file.name]: -1 })) // Error
        }
      }

      // 3. Obtener IDs de archivos existentes que no se van a eliminar
      const archivosExistentesIds = editData.archivosExistentes
        .filter(file => !editData.archivosAEliminar.includes(file.id))
        .map(file => file.id)

      // 4. Actualizar la cotización con todos los datos
      const updateData = {
        descripcion: editData.descripcion,
        tipoComprobante: editData.tipoComprobante,
        numeroComprobante: editData.numeroComprobante,
        docsVenta: [...archivosExistentesIds, ...nuevosDocsVenta]
      }

      console.log("Data a subir")
      console.log(updateData)

      await axios.put(`${BACKEND}/api/cotizaciones/${quoteSelected.id}`, updateData, {
        withCredentials: true
      })
      
      toast.success("Cambios guardados exitosamente")
      setOpenEditModal(false)
      setQuoteSelected(null)
      setEditData({
        descripcion: "",
        tipoComprobante: "",
        numeroComprobante: "",
        archivosVenta: [],
        archivosExistentes: [],
        archivosAEliminar: []
      })
      setUploadProgress({})
      getRecord()
    } catch (error) {
      toast.error("Error al guardar los cambios")
      console.log(error)
    } finally {
      setIsSaving(false)
    }
  }

  const [headersTableActive, setHeadersTableActive] = useState([]);


  const getRecord = async () => {
    try {
      setIsLoading(true)
      let url = `${BACKEND}/api/pagosCotizaciones?limit=0&where[pagado][equals]=true&where[cotizacion.estado][equals]=Exito&where[cotizacion.cliente.ruc][like]=${brandName}`
      if (month && year) {
        const start = new Date(year, month - 1, 1).toISOString()
        const endDate = new Date(year, month, 0)
        endDate.setHours(23, 59, 59, 999)
        const end = endDate.toISOString()
        url += `&where[and][0][fechaLimite][less_than_equal]=${end}&where[and][1][fechaLimite][greater_than_equal]=${start}`
      }
      const response = await axios.get(url)
      setRecord(response.data.docs)
    } catch (error) {
      toast.error("Error al obtener los datos")
    } finally { 
      setIsLoading(false)
    }
  }

  const refetch = () => {
    getRecord()
  }

  const exportToExcel = () => {
    if (!record || record.length === 0) {
      toast.error("No hay datos para exportar")
      return
    }

    try {
      // Preparar los datos para Excel
      const excelData = record.map((r, index) => {
        // Calcular subtotal, IGV y total basándose en montosServicios
        let subtotal = 0;
        let igv = 0;
        
        
        if (r.montosServicios && Array.isArray(r.montosServicios)) {
          r.montosServicios.forEach(servicio => {
            const monto = servicio.monto || 0;
            subtotal += monto;
            
            // Si el servicio tiene IGV, calcular el 18%
            if (servicio.igv === "si") {
              igv += monto * 0.18;
            }
          });
        }
        
        const total = subtotal + igv;
        const payed = r.pagado;

        return {
          "N°": index + 1,
          "ID Cotización": r.cotizacion?.id,
          "Fecha de emisión": r.fechaPagoReal ? FormatDateStringGMT5(r.fechaPagoReal) : "-",
          "RUC": r.cotizacion?.cliente?.ruc || "-",
          "Razón social": r.cotizacion?.cliente?.razonSocial || "-",
          "Descripción": r.descripcion || "-",
          "Tipo de comprobante": r.cotizacion?.tipoComprobante || "-",
          "N° de comprobante": r.cotizacion?.numeroComprobante || "-",
          "Subtotal (S/.)": subtotal.toLocaleString('es-PE', {minimumFractionDigits: 2, maximumFractionDigits: 2}),
          "IGV (S/.)": igv.toLocaleString('es-PE', {minimumFractionDigits: 2, maximumFractionDigits: 2}),
          "Importe total (S/.)": total.toLocaleString('es-PE', {minimumFractionDigits: 2, maximumFractionDigits: 2}),
          "Tipo de venta": r.cotizacion?.tipoVenta || "-",
          "Comprobante de transacción": r.imagen ? r.imagen.url : "-",
          "Entidad de pago": r.banco + " - " + r.cuenta || "-",
          "Documentos de venta": r.cotizacion?.docsVenta && r.cotizacion?.docsVenta.length > 0 ? r.cotizacion?.docsVenta.map(doc => doc.url).join(", ") : "No",
          "Estado de pago": payed ? "Pagado" : "Pendiente",
          "Moneda": r.cotizacion?.moneda || "-"
        };
      });

      // Crear el workbook y worksheet
      const ws = XLSX.utils.json_to_sheet(excelData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Registro de Ventas");

      // Ajustar el ancho de las columnas
      const columnWidths = [
        { wch: 5 },   // N°
        { wch: 15 },  // ID Cotización
        { wch: 20 },  // Fecha de emisión
        { wch: 15 },  // RUC
        { wch: 30 },  // Razón social
        { wch: 40 },  // Descripción
        { wch: 20 },  // Tipo de comprobante
        { wch: 20 },  // N° de comprobante
        { wch: 15 },  // Subtotal
        { wch: 15 },  // IGV
        { wch: 18 },  // Importe total
        { wch: 20 },  // Tipo de venta
        { wch: 20 },  // Cantidad comprobantes
        { wch: 20 },  // Entidad de pago
        { wch: 20 },  // Documentos de venta
        { wch: 15 },  // Estado de pago
        { wch: 10 }   // Moneda
      ];
      ws['!cols'] = columnWidths;

      // Generar el nombre del archivo con fecha
      const fecha = new Date().toISOString().split('T')[0];
      const fileName = `Registro_Ventas_${fecha}.xlsx`;

      // Descargar el archivo
      XLSX.writeFile(wb, fileName);
      
      toast.success("Archivo Excel exportado exitosamente");
    } catch (error) {
      console.error("Error al exportar a Excel:", error);
      toast.error("Error al exportar el archivo Excel");
    }
  };

  const handleSearchClients = () => {
    getRecord()
  };
  
  const handleResetSearch = () => {
    setBrandName("");
  }

  useEffect(() => {
    getRecord()
  }, [month, year])

  useEffect(() => {
    getRecord()
  }, [])

  useEffect(() => {
    if (brandName === "") {
      getRecord();
    }
  }, [brandName])

  useEffect(() => {
    if (headersTableActive.length > 0) {
      localStorage.setItem("activeHeadersRegistroVentas", JSON.stringify(headersTableActive));
    }
  }, [headersTableActive]);

  useEffect(() => {
    const localActiveHeaders = JSON.parse(localStorage.getItem("activeHeadersRegistroVentas")) || [];
    if (localActiveHeaders.length > 0) {
      setHeadersTableActive(localActiveHeaders);
    } else {
      setHeadersTableActive(headers);
    }
  }, []);

  const headers = [
    {id: 1, name: "Editar", value: "actions", show: true, },
    {id: 2, name: "Fecha de emisión", value: "fechaPago", show: true, formatter: (value) => FormatDateStringGMT5(value)}, //FormatDateString - FormatDateTimeStringGMT5Midnight
    {id: 3, name: "Fecha de venta", value: "fechaPagoReal", show: true, formatter: (value) => FormatDateStringGMT5(value)}, //FormatDateString - FormatDateTimeStringGMT5Midnight
    {id: 4, name: "RUC", value: "cotizacion.cliente.ruc", show: true},
    {id: 5, name: "Razón social", value: "cotizacion.cliente.razonSocial", align: "start", show: true},
    {id: 6, name: "Descripción", value: "descripcion", show: true},
    {id: 7, name: "Tipo de comprobante", value: "cotizacion.tipoComprobante", show: true},
    {id: 8, name: "N° de comprobante", value: "numeroComprobante",  show: true},
    {id: 9, name: "Subtotal", value: "subtotal", show: true, formatter: (value) => ParseNumberToFloat({number: value})},
    {id: 10, name: "IGV", value: "igv", show: true, formatter: (value) => ParseNumberToFloat({number: value})},
    {id: 11, name: "Importe total", value: "total", show: true, formatter: (value) => ParseNumberToFloat({number: value})},
    {id: 12, name: "Tipo de venta", value: "cotizacion.tipoVenta", show: true},
    {id: 13, name: "Comprobante de transacción", value: "imagenes", show: true},
    {id: 14, name: "Entidad de pago", value: "cuentaBancaria", show: true},
    {id: 15, name: "Documentos de venta", value: "documentos", show: true}, 
    {id: 16, name: "Estado de pago", value: "pagado", show: true, customColor: { Opt1: "text-red-500", Opt2: "text-green-500" }},
    {id: 17, name: "Moneda", value: "cotizacion.moneda", show: true},
    {id: 18, name: "ID Cotización", value: "cotizacion.id", show: true},
  ]

  return (
    <div className="flex flex-col h-screen w-full">

      <FilterHeadersDialog
        open={openHeadersFilter}
        setOpen={setOpenHeadersFilter}
        activeCols={headersTableActive}
        setActiveCols={setHeadersTableActive}
      />  

      {/* Modal de detalles de la venta */}
      <Modal
        activeModal={openEditModal}
        onClose={() => {
          setOpenEditModal(false); 
          setQuoteSelected(null);
          setEditData({
            descripcion: "",
            tipoComprobante: "",
            numeroComprobante: "",
            archivosVenta: [],
            archivosExistentes: [],
            archivosAEliminar: []
          });
          setUploadProgress({});
        }}
        title="Editar registro de venta"
        centered
        className="max-w-6xl"
      >
        <>
          {quoteSelected && (
            <div className="  p-4 max-h-[70vh] overflow-y-auto">

              {/* Información de la Venta */}
              <div className="bg-gray-50 p-4 rounded-lg">
                <h3 className="text-xs font-semibold text-gray-800 mb-4 flex items-center gap-2">
                  <FaReceipt className="text-green-600" />
                  Información de la Venta (Modificable)
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                  <InputFormValue
                    title="Fecha de Venta"
                    value={FormatDateTimeStringGMT5Midnight(quoteSelected.fechaVenta)}
                    icon={<FaCalendarAlt />}
                    disabled={true}
                  />
                  <InputFormValue
                    title="Tipo de Comprobante"
                    value={editData.tipoComprobante}
                    setValue={(value) => handleEditChange('tipoComprobante', value)}
                    icon={<FaReceipt />}
                    type="select"
                    options={opcionesTipoComprobante}
                    required={true}
                  />
                  <InputFormValue
                    title="N° de Comprobante"
                    value={editData.numeroComprobante}
                    setValue={(value) => handleEditChange('numeroComprobante', value)}
                    icon={<FaBarcode />}
                    placeholder="Ingrese el número de comprobante"
                    required={true}
                  />
                  <InputFormValue
                    title="Tipo de Venta"
                    value={quoteSelected.fuenteVentas || "-"}
                    icon={<FaStore />}
                    disabled={true}
                  />
                  <InputFormValue
                    title="Moneda"
                    value={quoteSelected.moneda || "-"}
                    icon={<FaMoneyBillWave />}
                    disabled={true}
                  />
                  <div className="col-span-full">
                    <InputFormValue
                      title="Descripción"
                      type="textarea"
                      value={editData.descripcion}
                      setValue={(value) => handleEditChange('descripcion', value)}
                      icon={<FaFileAlt />}
                      placeholder="Ingrese una descripción"
                      required={true}
                      className="text-xs rounded-l-none rounded-r-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5 h-20 resize-none"
                    />
                  </div>
                </div>
              </div>

              {/* Documemntos de Venta */}
              <div className="bg-gray-50 p-4 rounded-lg">
                <h3 className="text-xs font-semibold text-gray-800 mb-4 flex items-center gap-2">
                  <FaFileInvoiceDollar className="text-indigo-600" />
                  Documentos de Venta (Modificable)
                </h3>
                <div className="space-y-4">
                  {/* Subida de archivos */}
                  <div>
                    <label className="block text-xs font-medium text-gray-600 mb-2">
                      Subir archivos de venta *
                    </label>
                    <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:border-blue-400 transition-colors">
                      <input
                        type="file"
                        multiple
                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.xls,.xlsx"
                        onChange={handleFileUpload}
                        className="hidden"
                        id="file-upload"
                      />
                      <label htmlFor="file-upload" className="cursor-pointer">
                        <FaFileInvoiceDollar className="mx-auto h-12 w-12 text-gray-400 mb-4" />
                        <p className="text-xs text-gray-600 mb-2">
                          <span className="font-medium text-blue-600 hover:text-blue-500">
                            Haz clic para subir
                          </span>{" "}
                          o arrastra y suelta
                        </p>
                        <p className="text-xs text-gray-500">
                          PDF, DOC, DOCX, JPG, PNG, XLS, XLSX (máx. 10MB por archivo)
                        </p>
                      </label>
                    </div>
                  </div>

                  {/* Lista de archivos subidos */}
                  {editData.archivosVenta.length > 0 && (
                    <div>
                      <h4 className="text-xs font-medium text-gray-700 mb-3">Archivos nuevos a subir:</h4>
                      <div className="space-y-2">
                        {editData.archivosVenta.map((file, index) => {
                          const progress = uploadProgress[file.name] || 0
                          const isUploading = isSaving && progress > 0 && progress < 100
                          const isUploaded = progress === 100
                          const hasError = progress === -1
                          
                          return (
                            <div key={index} className="flex items-center justify-between bg-white p-3 rounded border border-blue-200">
                              <div className="flex items-center space-x-3">
                                <FaFileInvoiceDollar className={`${hasError ? 'text-red-500' : isUploaded ? 'text-green-500' : 'text-blue-500'}`} />
                                <div className="flex-1">
                                  <p className="text-xs font-medium text-gray-900">{file.name}</p>
                                  <p className="text-xs text-gray-500">
                                    {(file.size / 1024 / 1024).toFixed(2)} MB
                                  </p>
                                  {isUploading && (
                                    <div className="mt-1">
                                      <div className="w-full bg-gray-200 rounded-full h-1">
                                        <div 
                                          className="bg-blue-600 h-1 rounded-full transition-all duration-300" 
                                          style={{ width: `${progress}%` }}
                                        ></div>
                                      </div>
                                      <p className="text-xs text-blue-600 mt-1">Subiendo... {progress}%</p>
                                    </div>
                                  )}
                                  {isUploaded && (
                                    <p className="text-xs text-green-600 mt-1">✓ Subido exitosamente</p>
                                  )}
                                  {hasError && (
                                    <p className="text-xs text-red-600 mt-1">✗ Error al subir</p>
                                  )}
                                </div>
                              </div>
                              {!isSaving && (
                                <button
                                  type="button"
                                  onClick={() => handleRemoveFile(index)}
                                  className="text-red-500 hover:text-red-700 p-1"
                                  title="Eliminar archivo"
                                >
                                  <FaTimes className="h-4 w-4" />
                                </button>
                              )}
                            </div>
                          )
                        })}
                      </div>
                    </div>
                  )}

                  {/* Indicador de archivos marcados para eliminación */}
                  {editData.archivosAEliminar.length > 0 && (
                    <div className="mt-4 p-3 bg-red-50 border border-red-200 rounded-lg">
                      <h4 className="text-xs font-medium text-red-700 mb-2 flex items-center gap-2">
                        <FaTimes className="text-red-500" />
                        Archivos marcados para eliminación ({editData.archivosAEliminar.length})
                      </h4>
                      <p className="text-xs text-red-600 mb-3">
                        Estos archivos se eliminarán del servidor cuando guardes los cambios.
                      </p>
                      <div className="space-y-2">
                        {editData.archivosAEliminar.map((fileId) => {
                          const archivoOriginal = (quoteSelected.archivosVenta || []).find(file => file.id === fileId)
                          return (
                            <div key={fileId} className="flex items-center justify-between bg-red-100 p-2 rounded border border-red-300">
                              <div className="flex items-center space-x-2">
                                <FaFileInvoiceDollar className="text-red-500" />
                                <span className="text-xs text-red-700">
                                  {archivoOriginal?.name || archivoOriginal?.fileName || `Archivo ${fileId}`}
                                </span>
                              </div>
                              <button
                                type="button"
                                onClick={() => handleCancelRemoveExistingFile(fileId)}
                                className="text-green-600 hover:text-green-800 p-1"
                                title="Cancelar eliminación"
                              >
                                <FaCheck className="h-3 w-3" />
                              </button>
                            </div>
                          )
                        })}
                      </div>
                    </div>
                  )}

                  {/* Archivos existentes */}
                  {editData.archivosExistentes && editData.archivosExistentes.length > 0 && (
                    <div>
                      <h4 className="text-xs font-medium text-gray-700 mb-3">Archivos existentes:</h4>
                      <div className="space-y-2">
                        {editData.archivosExistentes.map((archivo, index) => (
                          <div key={archivo.id || index} className="flex items-center justify-between bg-white p-3 rounded border">
                            <div className="flex items-center space-x-3">
                              <FaFileInvoiceDollar className="text-green-500" />
                              <div>
                                <p className="text-xs font-medium text-gray-900">{archivo.name || archivo.fileName || `Archivo ${index + 1}`}</p>
                                <p className="text-xs text-gray-500">
                                  {archivo.size ? `${(archivo.size / 1024 / 1024).toFixed(2)} MB` : "Archivo existente"}
                                </p>
                              </div>
                            </div>
                            <div className="flex items-center space-x-2">
                              <button
                                type="button"
                                onClick={() => handleDownloadFile(archivo.id, archivo.name || archivo.fileName)}
                                className="text-blue-500 hover:text-blue-700 p-1"
                                title="Descargar archivo"
                              >
                                <FaSearch className="h-4 w-4" />
                              </button>
                              <button
                                type="button"
                                onClick={() => handleRemoveExistingFile(archivo.id, archivo.name || archivo.fileName)}
                                className="text-red-500 hover:text-red-700 p-1"
                                title="Eliminar archivo"
                              >
                                <FaTimes className="h-4 w-4" />
                              </button>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
           
          {/* Botones de acción */}
          <div className="flex justify-end space-x-4 pt-6">
            <button
              type="button"
              onClick={() => {
                setOpenEditModal(false);
                setQuoteSelected(null);
                setEditData({
                  descripcion: "",
                  tipoComprobante: "",
                  numeroComprobante: "",
                  archivosVenta: [],
                  archivosExistentes: [],
                  archivosAEliminar: []
                });
                setUploadProgress({});
              }}
              className="px-4 py-2 text-xs font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              Cancelar
            </button>
            <button
              type="button"
              onClick={handleSaveChanges}
              disabled={isSaving}
              className="px-4 py-2 text-xs font-medium text-white bg-blue-600 border border-transparent rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed flex items-center space-x-2"
            >
              {isSaving ? (
                <>
                  <FaSpinner className="animate-spin h-4 w-4" />
                  <span>Guardando...</span>
                </>
              ) : (
                <>
                  <FaSave className="h-4 w-4" />
                  <span>Guardar Cambios</span>
                </>
              )}
            </button>
          </div>
        </>
      </Modal>

      {/* NavBar */}
      <div className="flex flex-row px-4 py-2 bg-gray-100">
        <div className="flex flex-row w-full items-center gap-4 justify-between overflow-x-auto overflow-y-hidden px-4 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
          
          <div className="flex items-center gap-4 py-4">
            <FaChartBar className="text-zinc-700 text-2xl" />
            <h2 className="text-2xl font-bold text-zinc-700">Registro ventas</h2>
          </div>
          {
            user?.puesto?.toUpperCase() !== "GESTION ADMI" && (
              <Button
                onClick={exportToExcel} 
                variant="contained" 
                disabled={record.length === 0 || isLoading || isSaving}
                sx={{
                  fontSize: "12px",
                  fontWeight: "bold",
                  fontFamily: "poppins",
                  padding: "4px 24px",
                  backgroundColor: "#2e7d32",
                  transition: "all 0.3s ease",
                  textTransform: "none",
                  borderRadius: "8px",
                  minWidth: "180px",
                  maxWidth: "300px",
                  '&:hover': {
                    backgroundColor: "#1b5e20",
                  }
                }}
                endIcon={<FaFileExcel size={14} className="text-white"/>}
              >
                <span style={{ 
                  whiteSpace: "nowrap", 
                  overflow: "hidden", 
                  textOverflow: "ellipsis",
                  maxWidth: "300px"
                }}>
                  Exportar a Excel
                </span>
              </Button>
            )
          }


          <div className="flex flex-row gap-4 items-center justify-center">

            <div className="relative w-full">
              <input
                type="text"
                placeholder="Buscar marca"
                className="w-[16rem] text-xs text-gray-700 bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
                value={brandName}
                onChange={(e) => setBrandName(e.target.value)}
              />
              {brandName && (
                <FaTimes
                  onClick={() => handleResetSearch()}
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 cursor-pointer"
                />
              )}
            </div>
            
            <div>
              <Button 
                variant="contained"
                endIcon={<SearchIcon />}
                sx={{
                  fontSize: "12px",
                  fontWeight: "bold",
                  fontFamily: "poppins",
                  padding: "4px 24px",
                  backgroundColor: "#ff6400",
                  transform: "all",
                  animationDuration: "1000",
                  textTransform: "none",
                  borderRadius: "8px",
                  '&:hover': {
                    backgroundColor: "#bb4a03",
                  }
                }}
                onClick={() => handleSearchClients()}
              >
                Buscar
              </Button>
            </div>

          </div>

        </div>
      </div>

      {/* Filtros */}
      <div className="flex flex-row items-center justify-between w-full bg-gray-100 mb-0.5 mt-0.5 px-6 gap-2">
        <div className="flex flex-row items-center justify-center w-full">
          <div className="flex flex-row gap-4 items-center justify-center">
            <Selector
               title="Mes" 
               setter={setMonth} 
               value={month} 
               options={[{label: "Todos", value: ""}, ...months]}
             />

            <Selector 
              title="Año" 
              setter={setYear} 
              value={year} 
              options={years} 
            />

            <FilterButton
              content="Filtrar columnas"
              action={() => setOpenHeadersFilter(true)}
            />
          </div>
        </div>
      </div>

      {/* Body */}
      <div className="flex-grow overflow-y-auto">
        {isLoading ? (
          <LoadingScreen />
        ) : (
          record.length === 0 ? (
            <NoDataScreen />
          ) : (
            <table className="w-full text-xs">
              <thead className="sticky top-0 bg-gray-200 z-50">
                <tr className="text-gray-700 text-center text-xs font-bold z-50">
                  {headers.map((header, i) => (
                    headersTableActive.find((e) => e.id === header.id)?.show && (
                      <th key={i} className="px-2 py-3 text-center bg-[#FE6400] border-x border-gray-300 text-white z-50">
                        {header.name}
                      </th>
                    )
                  ))}
                </tr>
              </thead>
              <tbody>
                {record.map((r, i) => {

                  // Calcular subtotal, IGV y total basándose en montosServicios
                  let subtotal = 0;
                  let igv = 0;
                  
                  if (r.montosServicios && Array.isArray(r.montosServicios)) {
                    r.montosServicios.forEach(servicio => {
                      const monto = servicio.monto || 0;
                      subtotal += monto;
                      
                      // Si el servicio tiene IGV, calcular el 18%
                      if (servicio.igv === "si") {
                        igv += monto * 0.18;
                      }
                    });
                  }
              
                  const total = subtotal + igv;

                  const payed = r.pagado;

                  r.total = total;
                  r.payed = payed;
                  r.subtotal = subtotal;
                  r.igv = igv;

                  return (
                    <ItemRowRegistroVentas
                      item={r}
                      headers={headers}
                      headersTableActive={headersTableActive}
                      refetch={refetch}
                    />
                  )}
                )}
              </tbody>
            </table>
          )
        )}
      </div>
    
    </div>
  )
}

export default RegistroVentas